import { render, staticRenderFns } from "./OverseaLogin.vue?vue&type=template&id=0d6b2d07&scoped=true&"
import script from "./OverseaLogin.vue?vue&type=script&lang=js&"
export * from "./OverseaLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6b2d07",
  null
  
)

export default component.exports